import { Injectable } from '@angular/core';
import { API_SERVICES_CONFIG, NonPaginatedResourceConfig, PortalHttpClient } from '@grid-ui/common';
import { Observable } from 'rxjs';
import { ApiCountryRiskAutocompleteSuggestions, CountryRiskAutocompleteParams } from '../model';

@Injectable()
export class CountryRiskAutocompleteService {
  private profileResourcesConfig: NonPaginatedResourceConfig;
  private insightResourcesConfig: NonPaginatedResourceConfig;

  constructor(private readonly http: PortalHttpClient) {
    this.profileResourcesConfig = API_SERVICES_CONFIG.nessie.profiles.autocomplete._configuration;
    this.insightResourcesConfig = API_SERVICES_CONFIG.nessie.insights.autocomplete._configuration;
  }

  public getAutocompleteSuggestions(params: CountryRiskAutocompleteParams): Observable<ApiCountryRiskAutocompleteSuggestions> {
    return this.http.get<ApiCountryRiskAutocompleteSuggestions>(
      params.section === 'snapshots' ? this.profileResourcesConfig : this.insightResourcesConfig,
      {
        queryParams: {
          search: params.search,
          page: params.page,
          page_size: params.page_size,
        },
        pathParams: { section: params.section },
      },
    );
  }
}
